import styled from 'styled-components';

export const StyledSongActivity = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  max-height: 100%;

  .activity-content {
    height: 100%;
    width: 100%;
    display: flex;
    flex-direction: column;
  }

  .lyric-image {
    flex: 1;
    height: 0;
    width: 99%;
    overflow-y: scroll;
  }

  &.with-image {
    flex: 1;
    max-height: 100%;

    .player-wrapper {
      flex: 1;
      max-height: 66px;
    }
  }
  .song-player-wrapper {
    margin-bottom: 30px;
    width: 100%;
    height: 50px;
  }
  a {
    display: block;
    text-align: center;
  }
  .pdf {
    margin-top: 40px;
  }
`;
